import React, { useEffect, useState } from 'react'
import Hero from '../components/common/hero'
import { Link, useParams } from 'react-router-dom'

import '../assets/css/home/blogdetails.scoped.css'

import placeHolder from '../assets/images/placeholder.png'



import Faq from '../components/common/faq'
import axios from 'axios'
import apiUrl from '../services/apiUrl'
import parse from 'html-react-parser'

function NewsDetailsPage() {
    const { newsId } = useParams()
    const [faqs, setfaqs] = useState([])
    const [news, setnews] = useState({});


    useEffect(async () => {
        getNews()
        getSingleBlogFaq()



    }, [])


    const getSingleBlogFaq = async () => {
        try {
            var response = await axios.post(apiUrl.getSingleBlogFaq, { blog_id: newsId })
            if (response.data?.data?.blogFaq) {
                setfaqs(response.data.data.blogFaq)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getNews = async () => {
        try {
            var response = await axios.post(apiUrl.getNewsDetails, { cms_id: newsId })
            if (response?.data?.data) {
                setnews(response.data.data)
            }
        } catch (error) {
            console.error(error)
        }
    }






    return (
        <>
            <Hero />
            <section className="blog-section">
                <div className="col-12 main-pd">
                    <div className="row blog-detail-contr">
                        <div className="col-12">
                            <img src={news?.image ? `${apiUrl.host}/storage/${news.image}` : placeHolder} alt="" />
                        </div>
                        <div className="col-8">
                            <div className="blog-list">
                                <h2>{news?.title}</h2>
                                <div className="content">
                                    {parse(`${news?.content}`)}
                                </div>
                                <div className="content">
                                    {parse(`${news?.meta_description || ''}`)}
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>


            <Faq faqlist={faqs} />
        </>
    )
}

export default NewsDetailsPage